<div class="dynamic-field-container" [class.selected]="config?.selected">
  <div
    class="dynamic-field form-input text-align"
    [formGroup]="group"
    [hidden]="!config?.isFormBuilder && config?.options?.hidden"
  >
    <ups-dynamic-helper-label
      [config]="config"
      [dynamicService]="dynamicService"
    ></ups-dynamic-helper-label>
    <div class="job-search-container" style="position: relative">
      @if (!config?.options?.isMultiSelect) {
        <kendo-dropdownlist
          #dropdown
          class="k-no-dropdown w-100"
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          [valuePrimitive]="false"
          [textField]="'OfficeLocation'"
          [valueField]="'OfficeLocation'"
          [defaultItem]="{ OfficeLocation: config?.placeholder }"
          [filterable]="true"
          (valueChange)="valueChangeItem($event)"
          search-ex
          [seSearchColumns]="['OfficeLocation', 'Address', 'City', 'Zip']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.OfficeLocation === config?.placeholder"
            >
              <div>
                @if (dataItem.OfficeLocation) {
                  <span class="job-name link-style">
                    {{ dataItem.Company }} - {{ dataItem.OfficeLocation }}
                  </span>
                }
                @if (dataItem.Address) {
                  <div class="clearBoth">
                    <div style="display: inline-block">
                      {{ dataItem.Address }}
                    </div>
                  </div>
                }
                <div class="clearBoth">
                  <span style="margin-right: 0">
                    {{ dataItem.City || 'n/a' }}
                  </span>
                  <span style="margin-right: 0">
                    {{ dataItem.State ? ', ' + dataItem.State : '' }}
                  </span>
                  <span style="margin-right: 0">
                    {{ dataItem.Zip ? ' ' + dataItem.Zip : '' }}
                  </span>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.OfficeLocation">
                <span class="job-name">{{ dataItem.OfficeLocation }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-dropdownlist>
      } @else if (config?.options?.isMultiSelect) {
        <kendo-multiselect
          upsKeepSelectionOnEsc
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          class="k-no-dropdown w-100"
          [valuePrimitive]="false"
          [textField]="'OfficeLocation'"
          [valueField]="'OfficeLocation'"
          [placeholder]="config?.placeholder"
          [filterable]="true"
          (valueChange)="multiSelectValueChange($event)"
          search-ex
          [seSearchColumns]="['OfficeLocation', 'Address', 'City', 'Zip']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.OfficeLocation === config?.placeholder"
            >
              <div>
                @if (dataItem.OfficeLocation) {
                  <span class="job-name link-style">
                    {{ dataItem.OfficeLocation }}
                  </span>
                }
                @if (dataItem.Address) {
                  <div class="clearBoth">
                    <div style="display: inline-block">
                      {{ dataItem.Address }}
                    </div>
                  </div>
                }
                <div class="clearBoth">
                  <span style="margin-right: 0">
                    {{ dataItem.City || 'n/a' }}
                  </span>
                  <span style="margin-right: 0">
                    {{ dataItem.State ? ', ' + dataItem.State : '' }}
                  </span>
                  <span style="margin-right: 0">
                    {{ dataItem.Zip ? ' ' + dataItem.Zip : '' }}
                  </span>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template kendoMultiSelectValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.OfficeLocation">
                <span class="job-name">{{ dataItem.OfficeLocation }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-multiselect>
      }
    </div>
    <ups-dynamic-search-error [show]="searchError"></ups-dynamic-search-error>
    @if (config?.isFormBuilder) {
      <div
        class="form-builder-mask"
        [class.hidden]="config?.options?.hidden"
      ></div>
    }
  </div>
  @if (config?.isFormBuilder) {
    <div class="form-builder-options">
      <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
      <!-- <i class="fas fa-bars ms-3 cursor-grab"></i> -->
    </div>
  }
</div>
